export default {
  // getCurrentPermissionStatus: state => state.currentGeolocation.geolocationPermissionStatus
  getLockViewToCenter: state => state.lockViewToCenter,
  getTemporaryCenterOfManuallyMovedMap: state => state.temporaryCenterOfManuallyMovedMap,
  // Gelocation initial data (with address from reverse GeoLoc service)
  // For "live display" of geolocation data like speed, altitude...
  getCurrentGeolocation: state => state.currentGeolocation
  // getStartGeoLocData: state => state.startGeoLocData,
}

//
// ----- Singular data => performance impact if called non-stop!!! Be careful
//
// getCurrentLat: state => state.currentGeolocation.lat,
// getCurrentLon: state => state.currentGeolocation.lon,
// getCurrentAccuracy: state => state.currentGeolocation.accuracy,
// getCurrentAltitude: state => state.currentGeolocation.altitude,
// getCurrentAltitudeAccuracy: state => state.currentGeolocation.altitudeAccuracy,
// getCurrentHeading: state => state.currentGeolocation.heading,
// getCurrentSpeed: state => state.currentGeolocation.speed,
